import { Component, inject, OnInit } from '@angular/core';
import { DemandScienceDefault } from '@frontend/theme';
import { AuthService } from 'auth';
import { DataDogService } from 'datadog';
import { FullStoryService } from 'fullstory';
// import { GainsightService } from 'gainsight';
import { DataContextService, DataContextWaitingService } from 'lake-front-v2';
import { PrimeNG } from 'primeng/config';
import { StatReporterService } from 'stats-reporting';

@Component({
  selector: 'ds-terminus-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'demand-science';

  /** pre importing these services so that they can initialize */
  private authService = inject(AuthService);
  // private gainsightService = inject(GainsightService);
  private fullStoryService = inject(FullStoryService);
  private dataDogService = inject(DataDogService);
  private statsReporting = inject(StatReporterService);
  private dataContextService = inject(DataContextService);
  public dataContextWaitingService = inject(DataContextWaitingService);
  private primeNGConfig = inject(PrimeNG);

  ngOnInit() {
    this.primeNGConfig.setConfig({
      theme: {
        preset: DemandScienceDefault,
        options: {
          darkModeSelector: 'none',
        },
      },
    });
  }
}
